/*
 * Faded Collective — clear-on-scroll header.
 *
 * Why this file exists: header.liquid renders a <sticky-header> element, but this
 * Dawn build never defines that custom element (no customElements.define for it in
 * assets/), so the stock scroll behaviour is inert. Rather than depend on missing
 * internals, this is self-contained: one passive scroll listener toggling one class.
 *
 * Adds .fc-header-scrolled to .header-wrapper once the page is scrolled past
 * THRESHOLD. All visual treatment lives in faded-custom.css.
 */
(function () {
  var THRESHOLD = 60;
  var header = document.querySelector('.header-wrapper');
  if (!header) return;

  var ticking = false;
  var last = null;

  function apply() {
    var scrolled = window.scrollY > THRESHOLD;
    if (scrolled !== last) {           // only touch the DOM on an actual state change
      header.classList.toggle('fc-header-scrolled', scrolled);
      last = scrolled;
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(apply);
    }
  }

  apply();                                            // correct state on load / refresh mid-page
  window.addEventListener('scroll', onScroll, { passive: true });
})();
